// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"e8016f22","244":"0f04f690","335":"65544b75","377":"e87e1a9f","587":"01001ce7","641":"ab73bdfe","724":"1a6acd05","842":"d72a019c"}[chunkId] + ".chunk.js";
};